import Vue from 'vue'
import Router from './router'

export default {
  httpErrorHandler: (error) => {
    let title = 'Please wait,'
    let notify = 'Processing'
    let color = 'warning'

    if (error.response) {
      let status = error.response.status
      let message = error.response.data.message

      if (status === 401) {
        localStorage.removeItem('userInfo')
        Router.push({ path: '/login' })
      } else if (status === 400) {
        if (
          error.request.responseType === 'blob' &&
          error.response.data instanceof Blob &&
          error.response.data.type &&
          error.response.data.type.toLowerCase().indexOf('json') != -1
        ) {
          let reader = new FileReader()
          reader.onload = () => {
            const err = JSON.parse(reader.result)

            if (typeof err.message != undefined) {
              notify = err.message.split('_').join(' ')
              title = 'Sorry'
              color = 'danger'
            }
          }

          reader.readAsText(error.response.data)
        } else {
          if (message != undefined) {
            notify = message.split('_').join(' ')
            title = 'Sorry'
            color = 'danger'
          }
        }
      }
    }

    setTimeout(() => {
      Vue.prototype.$vs.notify({
        title: title,
        text: notify,
        color: color,
        position: 'top-right'
      })
    }, 200)
  }
}
